export const iconFontAwesomePhotosImagesIdBadge = (
	<i className="fa-solid fa-id-badge"></i>
);
